/** Copyright (c) 2017 T. Rowe Price. All rights reserved. */

import styles from './RMDAccounts.module.scss';

import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import RMDTable from '../RMDTable/RMDTable';
import RMDTableMobile from '../RMDTableMobile/RMDTableMobile';
import Title from '../../Title/Title';
import { getRMDSummary } from '../../../../redux/modules/RMD/RMDSetting.selectors';
import { firstBusinessDay } from '../../../../utils/dashboard-utils';

const RMDAccounts = () => {
  const rmdSummary = useSelector(getRMDSummary);
  const currentRmdYear = rmdSummary.rmdYear;
  const [layoutType, setLayoutType] = useState('web');

  function changeMq() {
    setLayoutType(mq?.matches ? 'mobile' : 'web');
  }

  let mq = window?.matchMedia?.('screen and (max-width: 767px)');
  if (mq) mq.addListener(changeMq);

  /* eslint-disable */
  useEffect(() => {
    changeMq();
  }, []);
  /* eslint-enable */

  return (
    <div
      id="RMD-Accounts"
      className={`${styles['module']} ${styles['RMD-Accounts']}`}
    >
      <Title
        mainTitle={'your RMDs'}
        subTitle={`AS OF ${firstBusinessDay(currentRmdYear)}`}
      />
      {layoutType === 'web' ? <RMDTable /> : <RMDTableMobile />}
    </div>
  );
};

export default RMDAccounts;
